import {BifrostBackendApi, BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";
import {store} from "../store";

const VouchersProvider = {
	async findAll() {
		const res = await BifrostBackendApi.get("/vouchers", {
			params: {
				tenantId: appConfig.tenantId
			},
			headers: {
				Authorization: store.getters.jwtToken
			}
		});

		return res.data.sort(function(a,b){
			return new Date(b.updatedAt) - new Date(a.updatedAt);
		});
	},

	async insert({
		voucherCode,
		voucherName,
		expiryDate,
		isActive,
		maxNumberOfUsages = null,
		usesPerTransaction = 1,
		onlinePosProductId = null
	}) {
		return BifrostBackendApi.post(`/vouchers`, {
			tenantId: appConfig.tenantId,
			voucherName,
			voucherCode,
			expiryDate,
			isActive,
			maxNumberOfUsages,
			usesPerTransaction,
			onlinePosProductId
		}, {
			headers: {
				Authorization: store.getters.jwtToken
			}
		});
	},

	async delete(id) {
		return BifrostBackendApi.delete(`/vouchers/${id}`, {
			headers: {
				Authorization: store.getters.jwtToken
			},
			params: {
				tenantId: appConfig.tenantId
			}
		});
	},

	async get(id) {
		return BifrostBackendApi.get(`/vouchers/${id}`, {
			headers: {
				Authorization: store.getters.jwtToken
			},
			params: {
				tenantId: appConfig.tenantId
			}
		});
	},

	async update(id, data) {
		return BifrostBackendApi.put(`/vouchers/${id}?tenantId=${data.tenantId}`, data, {
			headers: {
				Authorization: store.getters.jwtToken
			}
		});
	},

	async redeemVoucher(voucherCodeOrId, shopId = null) {
		const res = await (store.getters.featureToggles.useNewDiscountsModel ? BifrostBackendNestApi : BifrostBackendApi)
			.get(store.getters.featureToggles.useNewDiscountsModel ? "/vouchers/_verify" : "/vouchers-verify", {
				params: {
					tenantId: appConfig.tenantId,
					voucherCodeOrId,
					shopId,
					channel: appConfig.channelAlias(),
					deliveryMethod: store.getters.tenantSpecificData && store.getters.tenantSpecificData.deliveryChoice
				},
				headers: {
					Authorizationidp: store.getters.applicationUserIdpToken
				}
			});
		return res.data;
	}
};

export default Object.freeze(VouchersProvider);
